import { trackAnalyticsEvent } from '@eventbrite/site-analytics';
import classNames from 'classnames';
import React, { useState } from 'react';
import { EventCard } from '../EventCard';
import {
    GA_EVENT_CARD_OVERFLOW_MENU_CLICKED,
    GA_WILL_DISMISS_EVENT,
    GA_WILL_SHARE_EVENT,
    MORE_ACTIONS,
} from '../EventCard/constants';
import { EventCardProps } from '../EventCard/types';
import { FlipCard } from '../FlipCard';
import { RemoveEventCard } from '../RemoveEventCard';
const localStorageRemoveEventToolipViewed =
    'search:eventCard:remove:tooltip:viewed';

export const DismissableEventCard: React.FunctionComponent<EventCardProps> = (
    props,
) => {
    const { isMobile, eventData, gaCategory, showMoreActions, onRemoveEvent } =
        props;

    const [showConfirmRemoveEvent, setShowConfirmRemoveEvent] = useState(false);
    const [showRemoveEventAnimation, setShowRemoveEventAnimation] =
        useState(false);
    const [showRemoveTooltip, setShowRemoveTooltip] = React.useState(false);

    React.useEffect(() => {
        if (!localStorage.getItem(localStorageRemoveEventToolipViewed)) {
            localStorage.setItem(localStorageRemoveEventToolipViewed, 'true');
            setShowRemoveTooltip(true);
        }
        return () => {
            // empty clean up
        };
    }, [setShowRemoveTooltip]);

    const handleUndoRemoveEvent = () => {
        setShowConfirmRemoveEvent(false);
    };

    const handleRemoveEvent = () => {
        setShowRemoveEventAnimation(true);
        setTimeout(() => {
            onRemoveEvent?.(eventData.id);
        }, 300);
    };

    const handleEventCardMoreAction = (val: string) => {
        gaCategory &&
            trackAnalyticsEvent({
                category: gaCategory,
                action: GA_EVENT_CARD_OVERFLOW_MENU_CLICKED,
                label: eventData.id,
            });

        if (val === MORE_ACTIONS.REMOVE_EVENT) {
            setShowConfirmRemoveEvent(true);
            gaCategory &&
                trackAnalyticsEvent({
                    category: gaCategory,
                    action: GA_WILL_DISMISS_EVENT,
                    label: eventData.id,
                });
        }

        if (val === MORE_ACTIONS.SHARE_EVENT) {
            gaCategory &&
                trackAnalyticsEvent({
                    category: gaCategory,
                    action: GA_WILL_SHARE_EVENT,
                    label: eventData.id,
                });
        }
    };

    const removeEventCard = (
        <div className="eds-event-card--consumer">
            <RemoveEventCard
                onRemoveEvent={handleRemoveEvent}
                onUndoRemoveEvent={handleUndoRemoveEvent}
            />
        </div>
    );

    const eventCard = (
        <EventCard
            {...props}
            onEventCardMoreAction={handleEventCardMoreAction}
            showRemoveTooltip={showRemoveTooltip}
        />
    );

    const eventCardClassNames = classNames('event-card__container', {
        'event-card__container--animate-removal': showRemoveEventAnimation,
    });

    return (
        <>
            {showMoreActions ? (
                <>
                    <div className={eventCardClassNames}>
                        <FlipCard
                            isMobile={isMobile}
                            showBack={showConfirmRemoveEvent}
                            cardFront={eventCard}
                            cardBack={removeEventCard}
                        />
                    </div>
                </>
            ) : (
                eventCard
            )}
        </>
    );
};
